import {NodeSpec} from 'prosemirror-model';

export interface CalloutAttrs {
  type: 'info' | 'warning' | 'danger' | 'success';
}

export const ICONS: Record<CalloutAttrs['type'], string> = {
  info: '\ue88e',
  warning: '\ue002',
  danger: '\uf654',
  success: '\ue86c',
};

export const callout: NodeSpec = {
  attrs: {
    type: {default: 'info'},
  },
  content: 'paragraph+',
  group: 'block',
  defining: true,
  draggable: true,
  parseDOM: [
    {
      tag: 'div[data-node="callout"]',
      getAttrs: (element: HTMLElement): CalloutAttrs => ({
        type: (element.getAttribute('data-type') as CalloutAttrs['type']) || 'info',
      }),
    },
  ],
  toDOM: (node) => {
    const {type} = node.attrs as CalloutAttrs;
    return [
      'div',
      {class: `pm-callout pm-callout--${type}`, 'data-node': 'callout', 'data-type': type},
      ['span', {class: `pm-callout__icon pm-callout__icon--${type} material-symbols-rounded icon--20`}, ICONS[type]],
      ['div', {class: 'pm-callout__content'}, 0],
    ];
  },
};
